// extracted by mini-css-extract-plugin
module.exports = {"container":"Popover_container__pqT7J","content":"Popover_content__evNI7"};